// extracted by mini-css-extract-plugin
export default {"circular_loader_container":"Loader_circular_loader_container__Lkpph","circular_loader":"Loader_circular_loader__wv6W+","spinner":"Loader_spinner__wDq1e"};